import { useQuery } from '@apollo/client';
import { Coordinates } from '@volkswagen-onehub/audi-feature-service-visitor-locator';
import { Data } from '../models/dealer';
import { BY_GEO_AREA } from '../utils/graphql/dealers';
import { toISO3CountryCode } from '../utils/i18n';

export default function useSearchByGeoArea(
  northEast: Coordinates,
  southWest: Coordinates,
  countryCode?: string,
  filters?: string[],
  userLat?: number,
  userLng?: number,
) {
  const { error, loading, data } = useQuery<
    Data,
    {
      northEastLat: number;
      northEastLng: number;
      southWestLat: number;
      southWestLng: number;
      country?: string;
      services?: string;
      userLat?: number;
      userLng?: number;
    }
  >(BY_GEO_AREA, {
    variables: {
      northEastLat: northEast.lat,
      northEastLng: northEast.lng,
      southWestLat: southWest.lat,
      southWestLng: southWest.lng,
      ...(countryCode && { country: toISO3CountryCode(countryCode) }),
      ...(filters?.length && { services: filters.join() }),
      userLat,
      userLng,
    },
    skip: [northEast.lat, northEast.lng, southWest.lat, southWest.lng].every((p) => p === 0),
  });

  return {
    error,
    loading,
    dealersResult: data?.dealersByGeoArea?.dealers,
  };
}
